$(function(){
  /*スムーススクロール*/
/*  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });*/
  
  /* スクロールで出現するヘッダーメニュー*/
	var scrollMenu = function() {
		var array = {
      '#page-top': 0,
			'#menu-1': 0,
			'#menu-2': 0,
			'#menu-3': 0
		};
		var $globalNavi = new Array();
		for (var key in array) {
			if ($(key).offset()) {
				array[key] = $(key).offset().top - 10;
				$globalNavi[key] = $('.follow-menu ul li a[href="' + key + '"]');
			}
		}
		$(window).scroll(function () {
			for (var key in array) {
				if ($(window).scrollTop() > array[key] - 50) {
					$('.follow-menu ul li a').each(function() {
						$(this).removeClass('active');
					});
					$globalNavi[key].addClass('active');
				}
			}
		});
	}
	scrollMenu();
  
  /*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 300) {
   $('.follow-menu').fadeIn(400);
   } else {
    $('.follow-menu').fadeOut(400);
  }
  });

  /*スクロールで表示*/
/*$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 50) {
   $('.is-flow').fadeIn(400);
   } else {
    $('.is-flow').fadeOut(400);
  }
  });*/
  
  /*下線スクロール*/
$(window).scroll(function (){
    $(".js-marker").each(function(){
      var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
      var scroll = $(window).scrollTop(); //スクロールの位置を取得
      var windowHeight = $(window).height(); //ウインドウの高さを取得
      if (scroll > position - windowHeight){ //スクロール位置が要素の位置を過ぎたとき
        $(this).addClass('active'); //クラス「active」を与える
      }
    });
});
  
      /*アコーディオンコンテンツ*/
     //.accordion-wrapの中のdt要素がクリックされたら
	$('.accordion-contents dt').click(function(){
 
		//クリックされた.accordion-contentsの中のdt要素に隣接するdd要素が開いたり閉じたりする。
		$(this).next('dd').slideToggle();
    
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
 
	});
  
  
  /*アンカーリンク付きタブ切り替え*/
  $('.view:eq(0)').addClass('active');
  $('.tab-tab').on('click',function(){
    $('.view').removeClass('active');
    $($(this).attr('href')).closest('.view').addClass('active');
  });
  
   // タブ クリックしたときの関数
  $('.tab-tab').click(function() {  
    // 〜〜タブについての処理〜〜
    // 一度タブについている'tab_current'を消し
    $('.tab-tab').removeClass('tab_current');
    //クリックされたタブのみに'tab_current'をつける。
    $(this).addClass('tab_current')
    });
  
});


$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});